import { pushRoute } from '../../../../lib/router.js';
import { isBase64Image } from '../../../../lib/utils.js';

export const stepGeneralNewUrl = 'projects/change-strategy/new/step-general';
export const stepGeneralEditUrl = 'projects/change-strategy/edit/step-general';
export const stepDetailsNewUrl = 'projects/change-strategy/new/step-details';
export const stepDetailsEditUrl = 'projects/change-strategy/edit/step-details';
export const stepGovernanceNewUrl =
  'projects/change-strategy/new/step-governance';
export const stepGovernanceEditUrl =
  'projects/change-strategy/edit/step-governance';
export const stepMilestonesNewUrl =
  'projects/change-strategy/new/step-milestones';
export const stepMilestonesEditUrl =
  'projects/change-strategy/edit/step-milestones';
export const stepLinkedFilesNewUrl =
  'projects/change-strategy/new/step-linked-files';
export const stepLinkedFilesEditUrl =
  'projects/change-strategy/edit/step-linked-files';
export const changeStrategyUrl = 'projects/change-strategy';

export const navigateToChangeStrategy = (projectId) =>
  pushRoute(changeStrategyUrl, { projectId });

export const navigateToStepGeneral = (editing, projectId) =>
  editing
    ? pushRoute(stepGeneralEditUrl, { projectId })
    : pushRoute(stepGeneralNewUrl, { projectId });

export const navigateToStepDetails = (editing, projectId) =>
  editing
    ? pushRoute(stepDetailsEditUrl, { projectId })
    : pushRoute(stepDetailsNewUrl, { projectId });

export const navigateToStepGovernance = (editing, projectId) =>
  editing
    ? pushRoute(stepGovernanceEditUrl, { projectId })
    : pushRoute(stepGovernanceNewUrl, { projectId });

export const navigateToStepMileStones = (editing, projectId) =>
  editing
    ? pushRoute(stepMilestonesEditUrl, { projectId })
    : pushRoute(stepMilestonesNewUrl, { projectId });

export const navigateToStepLinkedFiles = (editing, projectId) =>
  editing
    ? pushRoute(stepLinkedFilesEditUrl, { projectId })
    : pushRoute(stepLinkedFilesNewUrl, { projectId });

export const onReset = (editing, projectId) =>
  navigateToStepGeneral(editing, projectId);

export const generalStrategyStepValidate = (
  selectedImage,
  imageSize,
  values
) => {
  const errors = {};

  if (!values.project_impact) {
    errors.project_impact = 'Project Impact is required';
  }

  if (selectedImage && imageSize) {
    if (!isBase64Image(selectedImage)) {
      errors.avatar = 'Allowed formats: .jpeg, .png, .jpg';
    }
  }

  if (selectedImage && imageSize > 10485760) {
    errors.avatar = 'Max file size: 10Mb';
  }

  return errors;
};

export const milestonesStepValidate = (values) => {
  const errors = {};

  values.forEach((value, index) => {
    if (
      value[`name${index}`] ||
      value[`dateAt${index}`] ||
      value[`notes${index}`]
    ) {
      if (!value[`name${index}`]) {
        errors[`name${index}`] = 'Name is required';
      }
      if (!value[`dateAt${index}`]) {
        errors[`dateAt${index}`] = 'Date is required';
      }
    }
  });

  return errors;
};

export const linkedFilesStepValidate = (values) => {
  const errors = {};

  values.forEach((value, index) => {
    if (value[`name${index}`] || value[`url${index}`]) {
      if (!value[`name${index}`]) {
        errors[`name${index}`] = 'Name is required';
      }
      if (!value[`url${index}`]) {
        errors[`url${index}`] = 'URL is required';
      }
    }
  });
  return errors;
};
